import React, { useEffect, useState } from "react";
import {
  Typography,
  Paper,
  TextField,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { NewStyledNetflixButton } from "../Dashboard/Talent/Schedules/EditDeleteAvailability";
import { enqueueSnackbar } from "notistack";
import { useAuth } from "../../hooks";

interface RedeemPanelProps {
  earnedChips: number;
  setWalletData: React.Dispatch<
    React.SetStateAction<{ earned: number; purchased: number }>
  >;
}

const RedeemPanel: React.FC<RedeemPanelProps> = ({
  earnedChips,
  setWalletData,
}) => {
  const { userInfo, setUser } = useAuth();

  const [redeemAmount, setRedeemAmount] = useState<number>(earnedChips);

  useEffect(() => {
    setRedeemAmount(earnedChips);
  }, [earnedChips]);

  const [openDialog, setOpenDialog] = useState(false);

  const handleRedeemClick = () => {
    if (redeemAmount <= 0) {
      enqueueSnackbar("Amount must be greater than 0.", { variant: "warning" });
      return;
    }

    if (redeemAmount > earnedChips) {
      enqueueSnackbar("You cannot redeem more than your earned chips.", {
        variant: "error",
      });
      return;
    }

    setOpenDialog(true);
  };

  const handleConfirmRedemption = () => {
    setWalletData((prev) => ({
      ...prev,
      earned: prev.earned - redeemAmount,
    }));

    enqueueSnackbar(`Successfully requested to redeem ${redeemAmount} chips.`, {
      variant: "success",
    });

    setOpenDialog(false);
  };

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Redeem Chips
      </Typography>
      <Paper variant="outlined" sx={{ p: 3, borderRadius: 4 }}>
        <TextField
          fullWidth
          label="Amount to Redeem"
          type="number"
          inputProps={{ min: 0 }}
          value={redeemAmount}
          onChange={(e) => setRedeemAmount(Number(e.target.value))}
          sx={{ mb: 2 }}
        />
        <Typography variant="body2" color="text.secondary" mb={2}>
          Estimated conversion:{" "}
          <strong>${(redeemAmount * 0.1).toFixed(2)}</strong>
          <br />
          Redemption takes 1–3 business days.
        </Typography>
        <Divider sx={{ my: 2 }} />
        <NewStyledNetflixButton
          fullWidth
          disabled={redeemAmount <= 0}
          onClick={handleRedeemClick}
        >
          Request Redemption
        </NewStyledNetflixButton>
      </Paper>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Confirm Redemption</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to redeem <strong>{redeemAmount}</strong>{" "}
            chips? This will convert to{" "}
            <strong>${(redeemAmount * 0.1).toFixed(2)}</strong>.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <NewStyledNetflixButton onClick={handleConfirmRedemption}>
            Confirm
          </NewStyledNetflixButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RedeemPanel;
